module.exports = __webpack_public_path__ + "static/img/slide_3_fr.ebd5f71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_3_fr.svg
// module id = 8guU
// module chunks = 0